export default "__VITE_ASSET__C9N7DMOr__"